import React from "react";
import { connect, DispatchProp } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { field, Filter, utils } from "@mc/mc-legacy";
import * as pozadavkyActions from "../actions/pozadavkyActions";
import RequestPersonFilterField from "./filterField/RequestPersonFilterField";
import StateFilterField from "./filterField/StateFilterField";

const fields = [
  {
    name: "fulltext",
    label: "Vyhledat",
    defaultValue: "",
    component: field.Search,
  },
  {
    name: "requestPersonIdList",
    label: "Předkladatelé",
    component: RequestPersonFilterField,
    initialValue: [],
    componentProps: {
      attrName: "uplneJmeno",
    },
  },
  {
    name: "stateList",
    label: "Stav dokumentu",
    component: StateFilterField,
    initialValue: [],
  },
  {
    name: "dateRange",
    label: "Datum podepsání / odmítnutí",
    component: field.DateRangeField,
  },
];

type Props = { itemList: { allIds: number[]; fetched: boolean; filter: any }; dispatch: ThunkDispatch<any, any, any> };

/**
 * Výsledek vyhledávání filter
 */
class VysledkyVyhledaniFilter extends React.Component<Props> {
  onChange = (values) => {
    this.props.dispatch(pozadavkyActions.filter(values));
  };

  render() {
    const { itemList } = this.props;
    return (
      <div className={"mb-3 d-none d-md-block"}>
        <Filter fields={fields} values={itemList.filter} onChange={this.onChange} />
        {itemList.fetched && (
          <div className="mt-5">
            Počet nalezených položek: <span className="count">{itemList.allIds.length}</span>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    itemList: utils.storeFromArea(state, pozadavkyActions.POZADAVKY_SEARCH_LIST),
  };
}

export default connect(mapStateToProps)(VysledkyVyhledaniFilter);
